<template>
    <div id="seeker-age-employement">
        <div class="panel-seeker-age-employement">
            <div id="audience" type="question">
                <div class="panel-audience">

                        <h2 class="page-header">Zoek je een coach met een specialisatie?</h2>
                        <div class="radio-container">
                            <div class="radio-wrapper"><label><input type="radio" v-model="toggle" value="no"><span class="tick">Nee, ik heb geen voorkeur</span></label></div>
                            <div class="radio-wrapper"><label><input type="radio" v-model="toggle" value="yes"><span class="tick">Ja, namelijk</span></label></div>
                        </div>
                        <div class="two-column checkboxes-container" v-show="toggle === 'yes'">
                            <div class="checkbox-wrapper" v-for="specialization in allSpecializations" :key="specialization.id">
                                <label>
                                    <input type="checkbox" :value="specialization.id" v-model="answer.specializations">
                                    <span class="tick">{{ specialization | alternative_title }}</span>
                                </label>
                            </div>
                        </div>


                </div>
            </div>
            <div class="buttons-container">
                <previous-button />
                <next-button :is-valid="allValid" />
            </div>
        </div>
    </div>
</template>

<script>
    import PreviousButton from "../partials/PreviousButton";
    import NextButton from "../partials/NextButton";

    export default {
        name: 'Specialization',
        components: {NextButton, PreviousButton},
        computed: {
            allSpecializations: function() {
                return this.allFeatures.filter(function (feature) {
                    return feature.cluster === 'audience'
                })
            },
            allValid: function() {
                let toggleValid = this.toggle !== null
                let methodsValid = true;

                if (this.toggle === 'yes') {
                    methodsValid = this.answer.specializations.length > 0
                }

                return toggleValid && methodsValid;
            }
        },
        props: {
            isValid: {
                type: Function
            },
            answer: {
                type: Object
            },
            invalid: {
                type: Object
            },
            isAnswered: {
                type: Object
            }
        },
        filters: {
          alternative_title: f => f.title_alternative ? f.title_alternative : f.title,
        },
        data() {
            return {
                allFeatures: allFeatures,
                toggle: null
            }
        }
    }
</script>